import { render, staticRenderFns } from "./SlotItem.vue?vue&type=template&id=74a53646&scoped=true"
import script from "./SlotItem.vue?vue&type=script&lang=js"
export * from "./SlotItem.vue?vue&type=script&lang=js"
import style0 from "./SlotItem.vue?vue&type=style&index=0&id=74a53646&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a53646",
  null
  
)

export default component.exports